module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAgCAYAAADqgqNBAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABVSURBVEiJY2wMlPzPMECAaaAsHtmWs6AL1K9/zojMR08T6PKkAHSzRm6wj1o+avmo5XQBGCUcOqCkRCMERm6wj1o+avmo5aOWj1pOE8A42lcbcZYDAJsJDi2kpv5XAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic-hand-paper.png
// module id = wzxp
// module chunks = 0